const isSupport = _isLocalStorageUsable()

function probeSupport () {
  try {
    return (
      typeof localStorage !== 'undefined' &&
            'setItem' in window.localStorage &&
            !!window.localStorage.setItem
    )
  } catch (e) {
    return false
  }
}

function checkIfLocalStorageThrows () {
  const localStorageTestKey = '_localstorage_support_test'

  try {
    window.localStorage.setItem(localStorageTestKey, true)
    window.localStorage.removeItem(localStorageTestKey)
    return false
  } catch (e) {
    return true
  }
}

function _isLocalStorageUsable () {
  return probeSupport() && !checkIfLocalStorageThrows()
}

const Strorage = isSupport ? window.localStorage : {}
const debug = false
const LOGKEY = '__xgplayerlogkey'

const LOCAL_LOG = {
  set (value) {
    try {
      const localist = this.get()
      localist.push(value)
      Strorage.setItem(LOGKEY, JSON.stringify(localist))
    } catch (error) {
      debug && console.error('Strorage.set error', error)
    }
  },
  get () {
    try {
      let data = Strorage.getItem(LOGKEY)
      if (data) {
        data = JSON.parse(data)
      } else {
        data = []
      }
      return data
    } catch (error) {
      debug && console.error('Strorage.get error', error)
      return []
    }
  },
  remove () {
    try {
      Strorage.removeItem(LOGKEY)
    } catch (error) {
      debug && console.error('Strorage.removeItem error', error)
    }
  },
  clear () {
    try {
      Strorage.clear()
    } catch (error) {
      debug && console.error('Strorage.clear error', error)
    }
  }
}

export default LOCAL_LOG
